@if (vm(); as vm) {
	@if (
		!(
			(vm.vsnFeeCollection?.globalOptIn === null && vm.vsnFeeCollection?.eligibleForVsn === false) ||
			vm.vsnFeeCollection?.globalOptIn === false ||
			vm.vsnFeeCollection?.eligibleForVsn === false
		)
	) {
		@if (
			vm.vsnFeeCollection?.globalOptIn &&
			vm.vsnFeeCollection?.eligibleForVsn &&
			vm.vsnFeeCollection?.visionFeeDetail?.hasEnoughFunds &&
			vm.vsnFeeCollection?.enabled
		) {
			<div class="bonus">
				<div class="left">
					@if (vm.vsnFeeCollection?.visionFeeDetail?.bonus?.type === type.Asset) {
						{{ "fee_transparency_details_your_bonus" | translate }}
					} @else {
						{{ "fee_transparency_details_you_save" | translate }}
					}
				</div>
				<div class="right">
					@if (vm.vsnFeeCollection?.visionFeeDetail?.bonus?.type === type.Asset) {
						+{{
							vm.vsnFeeCollection?.visionFeeDetail?.bonus?.amount
								| tradable_precision_symbol
									: {
											id: vm.targetTradable.getId(),
											symbol: true,
											ignorePrecision: true
									  }
						}}
					} @else {
						{{
							vm.vsnFeeCollection?.visionFeeDetail?.bonus?.amount
								| fiat_precision_symbol
									: {
											id: vm.fiat?.getId(),
											currencies: [vm.fiat],
											symbol: true
									  }
						}}
					}
				</div>
			</div>
		}

		<div class="total">
			<div class="left">
				<p>{{ "swap_you_receive" | translate }}</p>
				<p class="approx">
					{{
						vm.sourceTotal
							| tradable_precision_symbol
								: { id: vm.sourceTradable?.getId(), txPrecision: true, noTrailingZeros: true }
					}}
					≈
					{{
						vm.targetTotal
							| tradable_precision_symbol
								: { id: vm.targetTradable?.getId(), txPrecision: true, noTrailingZeros: true }
					}}
				</p>
			</div>
			<div class="right">
				{{
					vm?.total
						| tradable_precision_symbol
							: {
									id: vm.targetTradable.getId(),
									symbol: true,
									ignorePrecision: true
							  }
				}}</div
			>
		</div>
	}
}
